export default "__VITE_ASSET__RD6wGSAD__"